import { Badge as FlowbiteBadge } from 'flowbite-react';
import './badge.css';

/**
 * Badge Component
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Badge content/text
 * @param {string} props.variant - Badge variant ('success', 'warning', 'failure', 'purple', 'gray', 'default')
 * @param {string} props.status - Status string to automatically determine color (overrides variant)
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.rest - Additional props passed to Flowbite Badge
 */
const Badge = ({
    children,
    variant = 'default',
    status,
    className = '',
    ...rest
}) => {
    const getVariantColor = () => {
        // If status is provided, determine color based on status
        if (status) {
            const normalizedStatus = status.toLowerCase();

            switch (normalizedStatus) {
                case 'completed':
                case 'feedback':
                    return 'success';
                case 'in_progress':
                    return 'purple';
                case 'pending':
                    return 'warning';
                case 'stopped_by_applicant':
                case 'abandoned':
                case 'closed':
                    return 'failure';
                case 'requested_human_interview':
                    return 'indigo';
                case 'not_sent':
                case 'new':
                case 'ats_declined':
                case 'unsupported_region':
                    return 'gray';
                default:
                    return 'default';
            }
        }

        // Otherwise use the variant prop
        switch (variant) {
            case 'success':
                return 'success';
            case 'warning':
                return 'warning';
            case 'failure':
                return 'failure';
            case 'purple':
                return 'purple';
            case 'gray':
                return 'gray';
            default:
                return 'default';
        }
    };

    return (
        <FlowbiteBadge
            color={getVariantColor()}
            className={`ui-badge inline-flex shrink-0 items-center justify-center whitespace-nowrap text-center !rounded-full ${className}`}
            {...rest}
        >
            {children}
        </FlowbiteBadge>
    );
};

export default Badge;
